import React, {  } from "react";
import { Card, Grid2 as Grid, Stack, Typography, useMediaQuery } from "@mui/material";
import { GenericCircleIcon } from "../../../components/generic/GenericCircleIcon";
import { UsersThree } from "@phosphor-icons/react";
import { useTheme } from "@emotion/react";
import { ACTIVE, DECLINED, INACTIVE, PENDING } from "../../../enums/statusEnums";

export const UserStats = ({ userStats }) => {
  const theme = useTheme();
  const isSm = useMediaQuery(theme.breakpoints.only('sm'));

  const stats = [
    {
      key: ACTIVE,
      label: <>Active {isSm && <br></br>}Users</>,
      color: 'primary.main',
    },
    {
      key: PENDING,
      label: <>For {isSm && <br></br>}Approval</>,
      color: 'warning.main',
      backgroundColor: 'warning.light'
    },
    {
      key: DECLINED,
      label: 'Declined',
      color: 'error.main',
      backgroundColor: 'error.light'
    },
    {
      key: INACTIVE,
      label: <>Inactive <br></br>Users</>,
      color: '#919EAB',
      backgroundColor: '#F4F6F8'
    }
  ];

  return (
    <Grid container spacing={2}>
      {
        stats?.map((item, index) => {
          return (
            <Grid item size={{ xs: 12, sm: 3 }} key={`stat-key-${index}`}>
              <Card sx={{ boxShadow: 'none' }}>
                <Grid container alignItems={'center'} spacing={3}>
                  <Grid item>
                    <GenericCircleIcon size={'95px'} backgroundColor={item?.backgroundColor} color={item?.color}>
                      <UsersThree size={58} />
                    </GenericCircleIcon>
                  </Grid>
                  <Grid item>
                    <Stack>
                      <Typography variant="h5" fontWeight={700}>
                        {userStats?.find((stat) => stat?.status == item?.key)?.value ?? 0}
                      </Typography>
                      <Typography fontWeight={700}>{item?.label}</Typography>
                    </Stack>
                  </Grid>
                </Grid>
              </Card>
            </Grid>
          );
        })
      }
    </Grid>
  );
};